"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnRedirectUri = exports.generateRedirectUri = void 0;
var isScopeListed_1 = require("./isScopeListed");
var normalizeUrl_1 = require("./normalizeUrl");
var SGWTConnectServerResponse_1 = require("./SGWTConnectServerResponse");
/**
 * Generates a redirect URI.
 *
 * Given the origin "https://example.com":
 *  - "" -> "https://example.com"
 *  - "/redirect" -> "https://example.com/redirect"
 *  - "https://example.com" -> "https://example.com"
 */
function generateRedirectUri(location, redirectUri) {
    var origin = "".concat(location.protocol, "//").concat(location.host);
    // Support empty or unspecified redirect_uri
    // by using the current origin instead:
    // "" => "https://example.com"
    if (!redirectUri) {
        return origin;
    }
    // Support URIs relative to origin, for example:
    // "/redirect" => "https://example.com/redirect"
    if (redirectUri.charAt(0) === '/') {
        return "".concat(origin).concat(redirectUri);
    }
    // Otherwise use the redirect_uri as provided.
    // Note that we're not trying to normalize it
    // because it will be compared as is on the
    // authorization server.
    return redirectUri;
}
exports.generateRedirectUri = generateRedirectUri;
/**
 * Determines if the current page has been redirected using OAuth2 protocol.
 */
function isOnRedirectUri(config, location) {
    //
    // Step 1: validate the fragment
    // --------------------
    var authEndpointResponse = (0, SGWTConnectServerResponse_1.parseOAuth2Fragment)(location.hash);
    // Ensure that the fragment has at least the "state" parameter,
    // otherwise this is not a valid OAuth2 fragment:
    if (!authEndpointResponse.hasOwnProperty('state')) {
        return false;
    }
    var hasRequestedAccessToken = (0, isScopeListed_1.isScopeListed)('token', config.response_type);
    var hasRequestedIdToken = (0, isScopeListed_1.isScopeListed)('id_token', config.response_type);
    var hasReceivedAccessToken = authEndpointResponse.hasOwnProperty('access_token');
    var hasReceivedIdToken = authEndpointResponse.hasOwnProperty('id_token');
    var hasReceivedError = authEndpointResponse.hasOwnProperty('error');
    if (hasRequestedAccessToken) {
        if (!hasReceivedAccessToken && !hasReceivedError) {
            return false;
        }
    }
    if (hasRequestedIdToken) {
        if (!hasReceivedIdToken && !hasReceivedError) {
            return false;
        }
    }
    //
    // Step 2: validate the href without fragment
    // --------------------
    // Remove the fragment from the current location and normalize it
    // to avoid infinite redirects due to non-strictly equal URIs:
    var currentUri = (0, normalizeUrl_1.normalizeUrl)(location.href.replace(location.hash, ''));
    // Compare to normalized redirect URI assuming that
    // it has no fragment (as per specification):
    return currentUri === (0, normalizeUrl_1.normalizeUrl)(config.redirect_uri);
}
exports.isOnRedirectUri = isOnRedirectUri;
//# sourceMappingURL=SGWTConnectRedirectUri.js.map